import React from "react";
import Button from "components/button";
import Icon from "components/icon";
import Input from "components/input";
import Select from "components/select";
interface ListFiltersProps {
  t: any;
  searchValue: string;
  setSearchValue: (val: string) => void;
  setCurrentPage: (page: number) => void;
  vehicleTypeFilter: string;
  setVehicleTypeFilter: (val: string) => void;
  vehicleTypeOptions: { label: string; value: string }[];
  vehicleModelFilter: string;
  setVehicleModelFilter: (val: string) => void;
  vehicleModelOptions: { label: string; value: string }[];
  statusFilter: string;
  setStatusFilter: (val: string) => void;
  isFilterActive: boolean;
  onClearFilter: () => void;
}

const ListFilters: React.FC<ListFiltersProps> = ({
  t,
  searchValue,
  setSearchValue,
  setCurrentPage,
  vehicleTypeFilter,
  setVehicleTypeFilter,
  vehicleTypeOptions,
  vehicleModelFilter,
  setVehicleModelFilter,
  vehicleModelOptions,
  statusFilter,
  setStatusFilter,
  isFilterActive,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3 w-full">
      <div className="flex-1">
        <Input
          value={searchValue}
          onChange={(event) => {
            setSearchValue(event.target.value);
            setCurrentPage(1);
          }}
          placeholder={t("search-placeholder-fsd")}
          leftIcon={<Icon name="search" size={14} />}
          reserveHelperSpace={false}
          data-testid="input-search-fleet"
          className="w-full"
        />
      </div>

      <div className="flex flex-col md:flex-row items-center gap-3 shrink-0">
        <div className="w-full lg:w-[200px]">
          <Select
            options={vehicleTypeOptions}
            value={vehicleTypeFilter}
            onValueChange={(value) => {
              setVehicleTypeFilter(value as string);
              setCurrentPage(1);
            }}
            placeholder={t("filter-type-placeholder")}
            reserveHelperSpace={false}
            data-testid="select-filter-type"
          />
        </div>

        <div className="w-full lg:w-[200px]">
          <Select
            options={vehicleModelOptions}
            value={vehicleModelFilter}
            onValueChange={(value) => {
              setVehicleModelFilter(value as string);
              setCurrentPage(1);
            }}
            placeholder={t("filter-model-placeholder")}
            reserveHelperSpace={false}
            data-testid="select-filter-model"
          />
        </div>

        <div className="w-full lg:w-[200px]">
          <Select
            options={[
              { label: t("filter-status-placeholder"), value: "" },
              { label: t("status-available"), value: "Available" },
              { label: t("status-assigned"), value: "Assigned" },
              { label: t("status-maintenance"), value: "Maintenance" },
              { label: t("status-inactive"), value: "Inactive" },
            ]}
            value={statusFilter}
            onValueChange={(value) => {
              setStatusFilter(value as string);
              setCurrentPage(1);
            }}
            placeholder={t("filter-status-placeholder")}
            reserveHelperSpace={false}
            data-testid="select-filter-status"
          />
        </div>

        {isFilterActive && (
          <Button
            type="button"
            variant="outline"
            color="tertiary"
            size="small"
            iconLeft={<Icon name="close-2" size={14} />}
            onClick={onClearFilter}
            className="border-none hover:bg-greyScale-50 px-2 shrink-0 h-10"
            data-testid="btn-clear-filter"
          >
            {t("btn-clear-filter")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ListFilters;
